<form [formGroup]="timeSpanForm">
  <div class="time-span-container">
    <shared-input-number-simple formControlName="days" [maxLength]="2" [min]="0" [max]="99" [unit]="'d'" placeholder="days" />
    <shared-input-number-simple formControlName="hours" [maxLength]="2" [min]="0" [max]="23" [unit]="'h'" placeholder="hours" />
    <shared-input-number-simple formControlName="minutes" [maxLength]="2" [min]="0" [max]="59" [unit]="'m'" placeholder="mins" />
    <shared-input-number-simple formControlName="seconds" [maxLength]="2" [min]="0" [max]="59" [unit]="'s'" placeholder="sec" />
  </div>
</form>
